const TyreSelections = (summary) => {
  const _quantities = {},
    _specifications = {},
    _tyres = {};
  let _asymmetrical = false,
    _specificationHasChanged = false;

  ['front', 'rear'].forEach((position) => {
    _specifications[position] = {
      get: function (measure) {
        validateSpecification(measure);
        return this[measure];
      },
      set: function (measure, value) {
        validateSpecification(measure);
        this[measure] = value;
      },
      setAll: function (specification) {
        this.width = specification.width;
        this.profile = specification.profile;
        this.rim = specification.rim;
        this.speed = specification.speed;
      },
      isValid: function () {
        try {
          return !!(
            this.width.toString().match(/\d{3}/) &&
            this.profile.toString().match(/\d{2}/) &&
            this.rim.toString().match(/\d{2}/) &&
            this.speed.match(/[NPQRSTUHVZWY]/)
          );
        } catch {
          return false;
        }
      },
      toParam: function () {
        if (!this.isValid()) return null;
        return this.width + '-' + this.profile + 'R' + this.rim + this.speed;
      },
      toString: function () {
        if (!this.isValid()) return null;
        return this.width + '/' + this.profile + 'R' + this.rim + this.speed;
      },
    };

    if (summary) {
      if (summary[position]) {
        quantity(position, summary[position].quantity);
        specification(position).setAll(summary[position].specification);

        if (summary.symmetrical) {
          tyre('both', { supplier_code: summary[position].supplier_code });
        } else {
          asymmetric(true);
          tyre(position, { supplier_code: summary[position].supplier_code });
        }
      }
    }
  });

  function quantity(position, value) {
    validatePosition(position);

    if (value === null || value === undefined) {
      return _quantities[position] || 0;
    } else {
      _quantities[position] = parseInt(value);
    }
  }

  function removeQuantity(position) {
    validateTyrePosition(position);

    _quantities[position] = null;
  }

  function specification(position) {
    validatePosition(position);

    return _specifications[position];
  }

  function specificationHasChanged(value) {
    if (value === null || value === undefined) {
      return _specificationHasChanged;
    } else {
      _specificationHasChanged = Boolean(value);
    }
  }

  function validatePosition(position) {
    if (!isValidPosition(position)) throw "position must be either 'front' or 'rear'";
  }

  function isValidPosition(position) {
    return position === 'front' || position === 'rear';
  }

  function validateSpecification(measure) {
    if (!isValidMeasure(measure)) throw "measure must be 'width', 'profile', 'rim' or 'speed'";
  }

  function isValidMeasure(measure) {
    return measure === 'width' || measure === 'profile' || measure === 'rim' || measure === 'speed';
  }

  function validateTyrePosition(position) {
    if (!isValidTyrePosition(position)) throw "position must be 'front', 'rear' or 'both'";
  }

  function isValidTyrePosition(position) {
    return position === 'front' || position === 'rear' || position === 'both';
  }

  function asymmetric(value) {
    if (value === null || value === undefined) {
      return _asymmetrical;
    } else {
      _asymmetrical = value;
    }
  }

  function tyre(position, value) {
    validateTyrePosition(position);

    if (value === null || value === undefined) {
      return _tyres[position];
    } else {
      _tyres[position] = value;
    }
  }

  function removeTyre(position) {
    validateTyrePosition(position);

    _tyres[position] = null;
  }

  return {
    quantity: quantity,
    removeQuantity: removeQuantity,
    quantities: function () {
      return { front: quantity('front'), rear: quantity('rear') };
    },
    totalQuantity: function () {
      return quantity('front') + quantity('rear');
    },
    hasFrontQuantity: function () {
      return Boolean(quantity('front'));
    },
    hasRearQuantity: function () {
      return Boolean(quantity('rear'));
    },
    hasQuantity: function () {
      return this.hasFrontQuantity() || this.hasRearQuantity();
    },
    specification: specification,
    specifications: function () {
      return { front: specification('front').toParam(), rear: specification('rear').toParam() };
    },
    asymmetric: asymmetric,
    symmetric: function () {
      //note symmetric and asymmetric ARE NOT inverse in this case
      //asymmetric represents the selection of front and rear being the same
      //symmetric is ONLY true if front and rear quantities are also both required
      if (asymmetric()) {
        return false;
      } else {
        return this.hasFrontQuantity() && this.hasRearQuantity();
      }
    },
    isFullySpecified: function () {
      const frontIsSpecified = this.hasFrontQuantity() && specification('front').isValid(),
        rearIsSpecified = this.hasRearQuantity && (this.symmetric() || specification('rear').isValid());
      return (frontIsSpecified || !this.hasFrontQuantity()) && (rearIsSpecified || !this.hasRearQuantity());
    },
    specificationHasChanged: specificationHasChanged,
    tyre: tyre,
    removeTyre: removeTyre,
    hasSelectedTyres: function () {
      return this.symmetric() ? Boolean(tyre('both')) : Boolean(tyre('front') || tyre('rear'));
    },
    clearTyreSelections: function () {
      ['front', 'rear', 'both'].forEach((position) => {
        removeTyre(position);
      });
    },
    positions: function () {
      const positions = [];
      if (this.hasFrontQuantity()) positions.push('front');
      if (this.hasRearQuantity()) positions.push('rear');
      return positions;
    },
  };
};

export default TyreSelections;
